import worksheetexample from "../assets/images/worksheetexample.png";
import strokeorder from "../assets/images/strokeorder.png";
import quiz from "../assets/images/quiz.png";
import typing from "../assets/gif/typing.gif";
import vocabulary from "../assets/images/vocabulary.png";

export default {
    typingwords: "日本語　勉強　飽きない　無料",
    header: {
        strokeOrder: "画面でよみかきれんしゅう",
        game: "ゲーム「どっちかな？」",
        typing: "フリック！タイプ！",
        vocabulary: "これ、いえる？単語スワイプ",
        worksheets: "無料プリントをダウンロードする",
        about: "会社について",
        contact: "お問い合わせ",
        message: "レッスンを予約する",
    },
    hero: {
        title: "はなぴんと3ヶ国語",
        text: "友だちがどんどんできる！飽きない学習コンテンツ",
        button: "さっそく始める",
    },
    cards: [
        { href: "/strokeorder", title: "画面でよみかきれんしゅう", desc: "オンラインでひらがなとカタカナの音を聞きながら書き順練習ができます！", image: strokeorder },
        { href: "/game", title: "ゲーム「どっちかな？」", desc: "形が似ているひらがなやカタカナ、見分けられるかな？", image: quiz },
        { href: "/vocabulary", title: "これ、いえる？単語スワイプ", desc: "単語カードをスワイプして、日本語の語彙をどんどん増やそう！", image: vocabulary },
        { href: "/typing", title: "フリック！タイプ！", desc: "きこえたことばをフリックかローマじでうちこもう！", image: typing },
        { href: "/writing", title: "おうちで使える無料プリント", desc: "印刷したりiPadにダウンロードしたりして書く練習ができます！", image: worksheetexample},
    ],
    about: {
        hanapin: "「はなぴん」は、「キッズから大人まで、世界中の人たちとフレンズになりたい！」と壮大な野望を持つはなぴんが講師を務めている日本語教育コンテンツです。日本語・英語・中国語の三カ国語で日常生活に役立つ日本語を学ぶことができます。教材の準備から授業、そして復習までの全てを、どこでも、いつでも、ひとりでも、完結できます。英語版はYouTube、中国語版はbilibiliに更新しておりますのでぜひご覧ください。",
        fujiyama: "株式会社ふじやまは、「はなぴん」の企画・アニメーション制作・編集を行なっている会社です。ゆるくユニークな世界観と、日常に役立つ実用性が両立した記憶に残るコンテンツを作ります。",
        profile: {
            companyName:    "会社名",
            established:    "設立",
            capital:        "資本金",
            representative: "代表",
            business:       "事業内容",
            address:        "所在地",
            qualifications: "資格",
            trademark:      "商標",
            bank:           "主要取引銀行",
        }
    },
    news: [
        { date: "2026.07.08", title: "「これ、いえる？単語スワイプ」が登場！", content: "画像と音声付きの単語カードをスワイプして、日本語の語彙をどんどん増やそう！", link: "/vocabulary", linkText: "やってみる" },
        { date: "2026.07.08", title: "「フリック！タイプ！」が登場！", content: "聞こえた日本語の単語をフリック入力やローマ字でタイピングする練習ができるよ！", link: "/typing", linkText: "やってみる" },
        { date: "2026.07.01", title: "オンラインで読み書き練習ができるようになりました", content: "オンラインでひらがなとカタカナの音を聞きながら書き順の練習ができます！", link: "/strokeorder", linkText: "れんしゅうする" },
        { date: "2026.06.30", title: "ゲーム「どっちかな？」が遊べるようになりました", content: "形が似ているひらがなやカタカナ、見分けられるかな？", link: "/game", linkText: "あそぶ" },
        { date: "2026.03.01", title: "最初のYouTube動画を公開しました！", content: "YouTubeよりご覧ください", link: "https://www.youtube.com/channel/UCXFOpp-skK2-psYqVwYOj1g", linkText: "YouTubeで見る" },
        { date: "2026.02.22", title: "当Webサイトを公開しました", content: "YouTubeにて新しい動画の公開をお待ちください", link: "", linkText: "" },
    ],
    characters: {
        hanapin: {
            name: "はなぴん",
            sub: "トリリンガルな食いしん坊",
            desc: "日本語の先生。アメリカと中国での留学経験を活かし、日本に興味のあるキッズたちに日本語を教えている。タピオカティーが大好きで毎日飲んでおり、中国本場の火鍋も大好き。"
        },
        emimaru: {
            name: "えみまる",
            sub: "天才的な画力を持つ酒豪",
            desc: "はなぴんのママ。自他共に認める酒豪であり画家として活躍している。海外旅行のために英語と中国語を勉強中だが、授業が終わるとすぐ忘れてしまうため中々上達しない。口癖は「くっそー」と「氷をください」。"
        },
        sakura: {
            name: "さくら",
            sub: "上海留学中の怠け者ブロガー",
            desc: "上海に留学に来た日本人の大学生。中国語が話せず、慣れない生活に戸惑っている。留学Vlogを編集して投稿を始めるものの、編集が追いつかず、フォロワーたちを待たせているのが毎日の気がかり。"
        },
    },
    sections: {
        otherLessons: "ほかの授業",
        studyMaterials: "学習教材",
        news: "お知らせ",
        characters: "キャラクター紹介",
        watchYouTube: "YouTubeで見る",
    },
    tags: {
        "cheat-sheet-test": "一覧&テスト",
        single: "1文字ずつ",
        all: "全文字",
        hiragana: "ひらがな",
        katakana: "カタカナ"
    }
};